// PRE-ORDER BUTTON LOGIC
// Supports re-initialization for instant navigation (color swatch content swaps)
(function() {
  var currentClickHandler = null;
  var countdownTimer = null;

  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

  function getContainerConfig() {
    var el = document.getElementById('line-item-preorder-section');
    if (!el) return { format: 'weeks', defaultWeeks: '2 - 3 weeks', defaultDate: '' };
    return {
      format:       el.getAttribute('data-message-format') || 'weeks',
      defaultWeeks: el.getAttribute('data-default-weeks')  || '2 - 3 weeks',
      defaultDate:  el.getAttribute('data-default-date')   || ''
    };
  }

  function formatDateNice(dateStr) {
    var d = new Date(dateStr + 'T00:00:00');
    if (isNaN(d.getTime())) return dateStr;
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  window.updateShippingCountdown = function(variantId) {
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }

    var target = document.getElementById('shipping-countdown');
    if (!target) return;

    var cfg = getContainerConfig();
    var container = document.getElementById('line-item-preorder-section');
    var messageSpan = container ? container.querySelector('.preorder-message') : null;

    var dateString = null;
    if (variantId && window.variantShippingDates && window.variantShippingDates[variantId]) {
      dateString = window.variantShippingDates[variantId];
    }

    if (cfg.format === 'date') {
      var displayDate = (dateString && dateString.trim() !== '') ? dateString : cfg.defaultDate;

      if (!displayDate || displayDate.trim() === '') {
        target.textContent = cfg.defaultWeeks || '2 - 3 weeks';
        if (messageSpan) {
          messageSpan.innerHTML = 'I understand that this item will ship in approximately '
            + '<span id="shipping-countdown" style="color:#1206b1; margin-left:4px;">'
            + (cfg.defaultWeeks || '2 - 3 weeks') + '</span>.';
        }
        return;
      }

      var shipDate = new Date(displayDate + 'T00:00:00');
      if (shipDate <= new Date()) {
        target.textContent = cfg.defaultWeeks || '2 - 3 weeks';
        if (messageSpan) {
          messageSpan.innerHTML = 'I understand that this item will ship in approximately '
            + '<span id="shipping-countdown" style="color:#1206b1; margin-left:4px;">'
            + (cfg.defaultWeeks || '2 - 3 weeks') + '</span>.';
        }
        return;
      }

      var niceDate = formatDateNice(displayDate);
      target.textContent = niceDate;
      if (messageSpan) {
        messageSpan.innerHTML = 'I understand that this item ships approximately '
          + '<span id="shipping-countdown" style="color:#1206b1; margin-left:4px;">'
          + niceDate + '</span>.';
      }
      return;
    }

    // "weeks" mode (default / legacy)
    if (!dateString || dateString.trim() === '') {
      target.textContent = cfg.defaultWeeks;
      return;
    }

    var shipDate = new Date(dateString + 'T00:00:00');

    function updateCountdown() {
      var t = document.getElementById('shipping-countdown');
      if (!t) return;
      var now  = new Date();
      var diff = shipDate - now;

      if (diff <= 0) {
        t.textContent = cfg.defaultWeeks;
        clearInterval(countdownTimer);
        return;
      }

      var daysUntilShip = Math.ceil(diff / (1000 * 60 * 60 * 24));
      var minWeeks = Math.ceil((daysUntilShip + 3) / 7);
      var maxWeeks = Math.ceil((daysUntilShip + 10) / 7);
      if (minWeeks === maxWeeks) maxWeeks = minWeeks + 1;

      t.textContent = minWeeks + ' - ' + maxWeeks + ' weeks';
    }

    updateCountdown();
    countdownTimer = setInterval(updateCountdown, 1000 * 60 * 60);
  };

  function initPreorderLogic() {
    var addToCartButton = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
    var preorderSection = document.getElementById('line-item-preorder-section');
    var preorderCheckbox = preorderSection ? preorderSection.querySelector('input[type="checkbox"]') : null;

    if (!addToCartButton || !preorderSection || !preorderCheckbox) return;

    function updateButtonAndLineItem(variant) {
      var btn     = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      var section = document.getElementById('line-item-preorder-section');
      var checkbox = section ? section.querySelector('input[type="checkbox"]') : null;

      if (!btn || !section || !checkbox) return;

      var variantId  = variant.id;
      var isPreOrder = (window.variantMetafields && window.variantMetafields[variantId] === "true");

      if (window.productStatus === "PRE-ORDER" || isPreOrder) {
        btn.dataset.preOrder = 'true';
        btn.textContent = 'Pre-order';
        section.style.display = 'block';
        checkbox.required = true;

        window.updateShippingCountdown(variantId);
      } else {
        btn.dataset.preOrder = 'false';
        btn.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to cart';
        section.style.display = 'none';
        checkbox.required = false;
      }
    }

    if (currentClickHandler) {
      document.removeEventListener('click', currentClickHandler);
    }

    currentClickHandler = function(event) {
      var btn = event.target.closest('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      if (!btn) return;

      var section  = document.getElementById('line-item-preorder-section');
      var checkbox = section ? section.querySelector('input[type="checkbox"]') : null;

      if (section && section.style.display === 'block' && checkbox && !checkbox.checked) {
        event.preventDefault();
        section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        section.classList.add('preorder-section-error');
        setTimeout(function() { section.classList.remove('preorder-section-error'); }, 2000);
      }
    };

    document.addEventListener('click', currentClickHandler, true);

    window.__updatePreorderButtonAndLineItem = updateButtonAndLineItem;

    var initialVariantInput = document.querySelector('[name="id"]');
    if (initialVariantInput && initialVariantInput.value) {
      var btn = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      if (btn) {
        setTimeout(function() {
          updateButtonAndLineItem({ id: initialVariantInput.value });
        }, 10);

        var initObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' || mutation.type === 'characterData' ||
                (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
              initObserver.disconnect();
              setTimeout(function() {
                updateButtonAndLineItem({ id: initialVariantInput.value });
              }, 10);
            }
          });
        });

        initObserver.observe(btn, {
          childList: true, characterData: true, attributes: true,
          attributeFilter: ['disabled']
        });
        setTimeout(function() { initObserver.disconnect(); }, 200);
      }
    }
  }

  document.addEventListener('variant:change', function(event) {
    var variant = event.detail.variant;
    if (variant && window.__updatePreorderButtonAndLineItem) {
      var btn = document.querySelector('.product-form__submit:not(.sticky-cart__form .product-form__submit)');
      if (btn) {
        window.__updatePreorderButtonAndLineItem(variant);

        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' || mutation.type === 'characterData' ||
                (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
              observer.disconnect();
              setTimeout(function() {
                window.__updatePreorderButtonAndLineItem(variant);
              }, 10);
            }
          });
        });

        observer.observe(btn, {
          childList: true, characterData: true, attributes: true,
          attributeFilter: ['disabled']
        });
        setTimeout(function() { observer.disconnect(); }, 200);
      }
    }
  });

  window.initPreorderLogic = initPreorderLogic;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorderLogic);
  } else {
    initPreorderLogic();
  }

  document.addEventListener('page:loaded', function() {
    setTimeout(initPreorderLogic, 10);
  });
})();